
import { BloqueioRodoviario, BloqueioTrechoRodoviario, Cia, Cidade, Markup, Moeda, Pacote, PacoteReserva, STATUSRESERVA, TarifarioRodoviario } from '../index';
import { Markdown } from '../gerenciamento/markup.model';
export class Rodoviario {
    Id: number;
    ReservaId: number;
    Nome: string;
    Adt: number;
    Chd: number;
    Inf: number;
    Localizador: string;
    WebServiceId: number;
    TarifarioRodoviario: TarifarioRodoviario;
    BloqueioRodoviario: BloqueioRodoviario;
    BloqueioTrechoRodoviario: BloqueioTrechoRodoviario[] = []
    TarifarioRodoviarioId: number;
    BloqueioRodoviarioId: number;
    DataIdaSaida: Date | moment.Moment;
    DataIdaChegada: Date | moment.Moment;
    DataVoltaSaida: Date | moment.Moment;
    DataVoltaChegada: Date | moment.Moment;
    CidadeOrigemChegada: Cidade;
    CidadeOrigemSaida: Cidade;
    CidadeOrigemChegadaId: number;
    CidadeOrigemSaidaId: number;
    CidadeDestinoSaida: Cidade;
    CidadeDestinoChegada: Cidade;
    CidadeDestinoSaidaId: number;
    CidadeDestinoChegadaId: number;
    Cia: Cia;
    CiaId: number;
    PacoteId: number;
    Pacote: Pacote;
    PacoteReservaId: number;
    PacoteReserva: PacoteReserva;
    MoedaNet: Moeda;
    MoedaNetId: number;
    MoedaListagem: Moeda;
    MoedaListagemId: number;
    MoedaFechamento: Moeda;
    MoedaFechamentoId: number;
    ValorVenda: number;
    ValorListagem: number;
    ValorFechamento: number;
    Taxa: number;
    Multiplica: boolean;
    ValorIRRF: number;
    ValorIRRFListagem: number;
    ValorIRRFFechamento: number;
    MarkupId: number;
    Markup: Markup;
    MarkdownId: number;
    Markdown: Markdown;
    Status: STATUSRESERVA;
    DataReserva: Date | moment.Moment;
    DataCancelamento: Date | moment.Moment;
    DataPagamento: Date | moment.Moment;
    PrazoCancelamento: Date | moment.Moment;
    PoliticaCancelamento: string;
    TaxaId: number;
    VoucherKey: string;
    VoucherValidacao: string;
    VoucherLogo: string;
    ValorNetExtra: number;
    ValorTaxaExtra: number;
    CodigoCliente: string;
    ExtraIntegracao: string;
    public ExtraIntegracao2: ExtraIntegracao;

}
class ExtraIntegracao {
    public Disponivel: number;
    public Reservado: number;
}
